import {SizeSelection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';
import {useSizeAdvisorRecommendation} from '../../../backend-services/ArticleDetail/AddToBasketSection/useSizeAdvisorRecommendation';
import {getSizeByIdOrLabel} from '../getSizeByIdOrLabel';
import {useRecommendedSizesCookie} from './useRecommendedSizesCookie';

export const useRecommendedSize = ({
  sizeSelection,
  productId,
  shouldUseSizeFinderAdviceRef,
}: {
  sizeSelection: SizeSelection;
  productId?: number;
  shouldUseSizeFinderAdviceRef?: React.MutableRefObject<boolean>;
}) => {
  const {recommendedSizes: recommendedSizesFromCookie} =
    useRecommendedSizesCookie();

  const beRecommendation = useSizeAdvisorRecommendation(sizeSelection);
  if (beRecommendation) {
    if (shouldUseSizeFinderAdviceRef) {
      shouldUseSizeFinderAdviceRef.current = true;
    }
    return beRecommendation;
  }

  const recommendedSizeFromCookie = recommendedSizesFromCookie?.find(
    recommendedSize =>
      !productId || (productId && productId === recommendedSize.id)
        ? getSizeByIdOrLabel({
            sizeSelection,
            sizeIdentifier: {type: 'label', label: recommendedSize.size},
          })
        : undefined,
  );

  const widgetRecommendedSize =
    recommendedSizeFromCookie?.size &&
    (!productId || (productId && productId === recommendedSizeFromCookie.id))
      ? getSizeByIdOrLabel({
          sizeSelection,
          sizeIdentifier: {
            type: 'label',
            label: recommendedSizeFromCookie.size,
          },
        })
      : undefined;

  if (widgetRecommendedSize) {
    return widgetRecommendedSize;
  }

  // Backend set `recommendedSizeId` for logged in users
  if (sizeSelection.recommendedSizeId) {
    const recoSize = getSizeByIdOrLabel({
      sizeSelection,
      sizeIdentifier: {type: 'id', id: String(sizeSelection.recommendedSizeId)},
    });
    return recoSize;
  }
};
